import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__ from "../../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__ from "../dropdown-menu.mjs";
const FilterActionButtons = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(__FilterActions);
function __FilterActions({ hasFilters: propHasFilters, actions: propActions, showSavingOptions = false, onUpdateExisting, onSaveAsNew }) {
    const contextData = propActions && void 0 !== propHasFilters ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const actions = propActions ?? contextData?.actions ?? {};
    const hasFilters = propHasFilters ?? (contextData?.filters.length ?? 0) > 0;
    if (!hasFilters) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                className: "rounded-lg w-8 md:w-fit",
                variant: "destructive",
                size: "sm",
                onClick: actions.clearAllFilters,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.FilterXIcon, {}),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                        className: "hidden md:block text-[13px] font-normal",
                        children: "Clear"
                    })
                ]
            }),
            actions.saveAllFilters && (showSavingOptions ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__.DropdownMenu, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__.DropdownMenuTrigger, {
                        asChild: true,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                            className: "font-normal text-[13px] rounded-lg",
                            variant: "outline",
                            size: "sm",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                                    type: "folder-bookmark",
                                    className: "w-4"
                                }),
                                "Save"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__.DropdownMenuContent, {
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__.DropdownMenuItem, {
                                onClick: onUpdateExisting || actions.saveAllFilters,
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.RefreshCw, {
                                        className: "size-3.5"
                                    }),
                                    "Update existing"
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_78dc7233__.DropdownMenuItem, {
                                onClick: onSaveAsNew || actions.saveAllFilters,
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Plus, {
                                        className: "size-4"
                                    }),
                                    "Save as new..."
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                className: "font-normal text-[13px] rounded-lg",
                variant: "outline",
                size: "sm",
                onClick: actions.saveAllFilters,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                        type: "folder-bookmark",
                        className: "w-4"
                    }),
                    "Save"
                ]
            }))
        ]
    });
}
export { FilterActionButtons };
